import { useMooConfig } from '../../provider';
import type { Source } from '../../types/sources';
import styles from './SourcesPopover.module.css';

export interface SourcesPopoverProps {
  readonly sources: Source[];
  readonly onClose: () => void;
}

/** List body for the "N Sources" popover. Each row is a button; clicking
 *  forwards to the host's `onSourceClick`. The library does not own any
 *  source-type → action mapping — see `MooChatConfig.onSourceClick`. */
export function SourcesPopover({ sources, onClose }: SourcesPopoverProps) {
  const { onSourceClick } = useMooConfig();

  const handleClick = (source: Source) => () => {
    if (onSourceClick) onSourceClick(source);
    onClose();
  };

  return (
    <div className={styles.popover}>
      {sources.map((source) => (
        <button
          key={source.id}
          type="button"
          className={styles.sourceItem}
          onClick={handleClick(source)}
          aria-label={`Open ${source.title}`}
        >
          <span className={styles.sourceIndex}>{source.citationIndex}</span>
          <span className={styles.sourceInfo}>
            <span className={styles.sourceTitle}>{source.title}</span>
            {source.description && (
              <span className={styles.sourceDescription}>
                {source.description}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
}
